import { Container } from "./styles";
import npmIcon from "../../assets/npm.svg"
import githubIcon from "../../assets/github-icon.svg"
import externalLinkIcon from "../../assets/external-link-icon.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Portfolio(){
  return(
    <Container id="portfolio">
      <h2>Portfolio</h2>

      <div className="projects">

      <ScrollAnimation animateIn="flipInX">
        <div className="project">
          <header>
          <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
          <div className="project-links">
          <a href="https://www.npmjs.com/package/vue-composable-utils" target="_blank" rel="noreferrer">
                <img src={npmIcon} alt="npm" />
              </a>
            <a href="https://github.com/vue-avengers/vue-composable-utils" target="_blank" rel="noreferrer">
              <img src={githubIcon} alt="GitHub" />
            </a>
            <a href="https://vue-composable-utils.netlify.app/" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a>
          </div>
          </header>
          <div className="body">
            <h3>Vue Composable Utils</h3>
            <p>Composable functions that have been brought together for you to use in all your components. <a href="https://vue-composable-utils.netlify.app/" target="_blank" rel="noreferrer"> vue-composable-utils</a>. Every time your component's render function changes, we have the full reactivity system 👨‍💻.
            </p>
          </div>
          <footer>
            <ul className="tech-list">
              <li>vue</li>
              <li>@vue/composition-api</li>
              <li>dayjs</li>
            </ul>
          </footer>
        </div>
      </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
            <a href="https://www.npmjs.com/package/vue-use-date" target="_blank" rel="noreferrer">
                <img src={npmIcon} alt="npm" />
              </a>
              <a href="https://github.com/vue-avengers/vue-use-date" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="GitHub" />
              </a>
              <a href="https://vue-use-date.netlify.app" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Vue Use Date</h3>
              <p>It's easy to use Vue Use Date APIs to parse, validate, manipulate, and display dates and times. <a href="https://vue-use-date.netlify.app/">vue-use-date</a>.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>vue</li>
                <li>@vue/composition-api</li>
                <li>dayjs</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
            <a href="https://www.npmjs.com/package/vue-use-embed" target="_blank" rel="noreferrer">
                <img src={npmIcon} alt="npm" />
              </a>
            <a href="https://github.com/vue-avengers/vue-use-embed" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="GitHub" />
              </a>
              <a href="https://vue-use-embed.netlify.app" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Vue Use Embed</h3>
              <p><a href="https://vue-use-embed.netlify.app">vue-use-embed.</a> implemented as vue composition functions. currently usable with the @vue/composition-api 👨‍💻.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>vue</li>
                <li>@vue/composition-api</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
            <a href="https://www.npmjs.com/package/fe-boilerplates-create" target="_blank" rel="noreferrer">
                <img src={npmIcon} alt="npm" />
              </a>
            <a href="https://github.com/jsdeveloperr/fe-boilerplates-create" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="GitHub" />
              </a>
              <a href="https://github.com/jsdeveloperr/fe-boilerplates-create#readme" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Frontend Boilerplates Create</h3>
              <p><a href="https://github.com/jsdeveloperr/fe-boilerplates-create">fe-boilerplates-create.</a> CLI for creating reusable, modern React, Preact, Vue, Svelte and Nextjs libraries 👨‍💻.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>Preact</li>
                <li>Vue</li>
                <li>Svelte</li>
                <li>Nextjs</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
            <a href="https://www.npmjs.com/package/favicon-badge-notify" target="_blank" rel="noreferrer">
                <img src={npmIcon} alt="npm" />
              </a>
            <a href="https://github.com/jsdeveloperr/favicon-badge-notify" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="GitHub" />
              </a>
              <a href="https://github.com/jsdeveloperr/favicon-badge-notify#readme" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Favicon Badge Notify</h3>
              <p><a href="https://github.com/jsdeveloperr/favicon-badge-notify">favicon-badge-notify.</a> Custom function adds a favicon and a badge 👨‍💻.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>Vue</li>
                <li>Solidjs</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
            <a href="https://www.npmjs.com/package/vue3-use-hooks" target="_blank" rel="noreferrer">
                <img src={npmIcon} alt="npm" />
              </a>
            <a href="https://github.com/jsdeveloperr/vue3-use-hooks" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="GitHub" />
              </a>
              <a href="https://vue3-use-hooks.vercel.app/" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Vue 3 Use Hooks</h3>
              <p><a href="https://github.com/jsdeveloperr/vue3-use-hooks">vue3-use-hooks.</a> Vue Use Hooks implemented as vue composition functions 👨‍💻.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Vue 3</li>
                <li>useStringCase</li>
                <li>useLocalStorage</li>
                <li>useModal</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
            <a href="https://github.com/jsdeveloperr/nextjs-boilerplate" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="GitHub" />
              </a>
              <a href="https://nextjs-12-boilerplate.vercel.app/" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>Next.js 12 Boilerplate</h3>
              <p><a href="https://github.com/jsdeveloperr/nextjs-boilerplate">nextjs-boilerplate.</a> Next js 12 boilerplate with Tailwind, SCSS, Jest, React Testing Library, Prettier, ESLint, Plop JS 👨‍💻.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>Next.js</li>
                <li>Tailwind</li>
                <li>React Testing Library</li>
                <li>SCSS</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
            <a href="https://github.com/jsdeveloperr/react-typscript-vite-redux-redux-saga-mui-boilerplate" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="GitHub" />
              </a>
              <a href="https://react-typscript-vite-redux-redux-saga-mui-boilerplate.vercel.app/" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>React Typscript Vite Redux Redux Saga Mui Boilerplate</h3>
              <p><a href="https://github.com/jsdeveloperr/react-typscript-vite-redux-redux-saga-mui-boilerplate">react-typscript-vite-redux-redux-saga-mui-boilerplate.</a> A boilerplate Create React App with Vite, Typescript, Redux Toolkit, Redux Saga, React Hook Form, React-i18next and Material UI 👨‍💻.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>React</li>
                <li>Redux</li>
                <li>Redux Saga</li>
                <li>Vite</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
            <svg width="50" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 24 24" fill="none" stroke="#23ce6b " stroke-width="1" stroke-linecap="round" stroke-linejoin="round" ><title>Folder</title><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
            <div className="project-links">
            <a href="https://github.com/jsdeveloperr/JS-dark-theme" target="_blank" rel="noreferrer">
                <img src={githubIcon} alt="GitHub" />
              </a>
              <a href="https://marketplace.visualstudio.com/items?itemName=AbdulnasirOlcan.js-dark-theme" target="_blank" rel="noreferrer">
                <img src={externalLinkIcon} alt="Visitar site" />
              </a>
            </div>
            </header>
            <div className="body">
              <h3>JS Dark Theme</h3>
              <p><a href="https://marketplace.visualstudio.com/items?itemName=AbdulnasirOlcan.js-dark-theme">The vscode</a> js dark theme 👨‍💻.
              </p>
            </div>
            <footer>
              <ul className="tech-list">
                <li>theme</li>
                <li>dark theme</li>
                <li>js dark theme</li>
                <li>theme dark js</li>
              </ul>
            </footer>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}